/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupContactsRoutingModule } from './builder-setup-contacts-routing.module';
import { ContactsTabContainerComponent } from './components/contacts-tab-container/contacts-tab-container.component';
import { CustomFieldDetailsDialogComponent } from './components/custom-field-details-dialog/custom-field-details-dialog.component';
import { CustomFieldListTabComponent } from './components/custom-field-list-tab/custom-field-list-tab.component';
import { LocationDetailsDialogComponent } from './components/location-details-dialog/location-details-dialog.component';
import { LocationListTabComponent } from './components/location-list-tab/location-list-tab.component';
import { CustomFieldListBusinessService } from './resources/custom-field-list-business.service';
import { LocationBusinessService } from './resources/location-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupContactsRoutingModule,
  ],
  providers: [
    LocationBusinessService,
    CustomFieldListBusinessService,
  ],
  declarations: [
    ContactsTabContainerComponent,
    LocationListTabComponent,
    LocationDetailsDialogComponent,
    CustomFieldListTabComponent,
    CustomFieldDetailsDialogComponent,
  ],
})
export class BuilderSetupContactsModule {
}
